import NextImage, { type ImageProps as NextImageProps } from "next/image"
import type { CSSProperties } from "react"
import { twMerge } from "tailwind-merge"

type Props = Omit<NextImageProps, "objectFit" | "objectPosition"> & {
  // These are deprecated in NextImage and meant to be passed as style. Our custom wrapper handles this
  objectFit?: CSSProperties["objectFit"]
  objectPosition?: CSSProperties["objectPosition"]
  imageClassName?: string
  containerClassName?: string
}

export type { Props as ImageProps }

/*
 * For small images, default quality to a bit higher than normally. NextImage by default uses 75, but
 * lets try defaulting to 80 for a bit better quality. Images are hopefully already optimized anyway.
 */
const SMALL_IMAGE_CONSTRAIN = 120
const calcQuality = ({ width, height }: Props) =>
  (width ? Number(width) : SMALL_IMAGE_CONSTRAIN + 1) <= SMALL_IMAGE_CONSTRAIN &&
  (height ? Number(height) : SMALL_IMAGE_CONSTRAIN + 1) <= SMALL_IMAGE_CONSTRAIN
    ? 90
    : 80

export const Image = ({
  objectFit = "cover",
  objectPosition = "center",
  style,
  children,
  quality,
  imageClassName,
  containerClassName,
  ...props
}: Props) => {
  const styleProps = style ?? {}

  return (
    <div className={twMerge("flex", containerClassName)} style={styleProps}>
      <NextImage
        style={{ objectFit, objectPosition }}
        className={twMerge("max-w-full h-auto", imageClassName)}
        quality={quality ?? calcQuality(props)}
        {...props}
      />
      {children}
    </div>
  )
}
